export class InvoiceSearchCriteria {
    contractId?: string;
    clientId?: string;
    country?: number;
    invoiceNumber?: string;
    invoiceName?: string;
    invoiceDate?: string;
}
